import React, { useEffect, useState } from "react";
import API_URL from "../../services/api";
import "./Dashboard.css";

const Dashboard = () => {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboard = async () => {
      try {
        const res = await fetch(`${API_URL}/api/dashboard`);
        const data = await res.json();

        setStats(data);
      } catch (err) {
        console.log("Dashboard Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboard();
  }, []);

  const cards = [
    {
      title: "Total Books",
      value: stats.totalBooks || 0,
      icon: "📚",
    },
    {
      title: "Books For Sale",
      value: stats.booksForSale || 0,
      icon: "🛒",
    },
    {
      title: "Library Books",
      value: stats.booksNotForSale || 0,
      icon: "🏛️",
    },
    {
      title: "Users",
      value: stats.totalUsers || 0,
      icon: "👥",
    },
    {
      title: "Staff Members",
      value: stats.totalStaff || 0,
      icon: "👨‍💼",
    },
    {
      title: "Events",
      value: stats.events || 0,
      icon: "📅",
    },
  ];

  return (
    <div className="dashboard-container">

      {/* Header */}
      <div className="dashboard-header">
        <div>
          <h1>Library Dashboard</h1>
          <p>
            Overview of your library management system
          </p>
        </div>
      </div>

      {/* Statistics */}
      <div className="dashboard-cards">

        {cards.map((card, index) => (
          <div className="dashboard-card" key={index}>

            <div className="dashboard-card-icon">
              {card.icon}
            </div>

            <div className="dashboard-card-content">

              <h2>
                {loading ? "..." : card.value}
              </h2>

              <p>{card.title}</p>

            </div>

          </div>
        ))}

      </div>

      {/* Welcome Section */}
      <div className="dashboard-welcome">

        <div className="welcome-icon">
          📖
        </div>

        <div>
          <h2>
            Welcome to the Librarian Dashboard
          </h2>

          <p>
            Manage books, announcements, users, staff,
            events and other library activities from
            one central location.
          </p>
        </div>

      </div>

    </div>
  );
};

export default Dashboard;